import { AlertModal, Text } from '@modusign/design-system';

interface PopUpBlockModalProps {
  isOpen: boolean;
  onConfirm: () => void;
}

const PopUpBlockModal = ({ isOpen, onConfirm }: PopUpBlockModalProps) => {
  return (
    <AlertModal
      isOpen={isOpen}
      maxWidth="xs"
      title="팝업 차단"
      variant="warning"
      onClose={onConfirm}
    >
      <Text as="p" fontSize={2}>
        팝업 차단이 설정되어 확인할 수 없습니다.
        <br />
        차단을 해체(팝업 허용)해 주세요.
      </Text>
    </AlertModal>
  );
};

export default PopUpBlockModal;
